import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { AxiosResponse } from 'axios';
import {
  CreateStatusDto,
  Status,
  StatusListResponse,
  UpdateStatusDto,
} from './StatusControl.type';

let listRequest: any = null;

const REQUEST_PREFIX = 'status';

export const statusControlService = {
  getList: (params: {
    q?: string;
    page?: number | string;
    perPage?: number;
  }): Promise<AxiosResponse<StatusListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`${REQUEST_PREFIX}/list`), {
      cancelToken: listRequest.token,
      params: { q: params.q, page: params.page, perPage: params.perPage },
    });
  },

  create: (data: CreateStatusDto): Promise<AxiosResponse<Status>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}/create`), data);
  },

  update: (data: UpdateStatusDto): Promise<AxiosResponse<Status>> => {
    return axios.put(getEndpointBase(`${REQUEST_PREFIX}/${data.id}`), data);
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
